export const transformPermission = permissions => {
  // Objeto para almacenar los valores de permiso
  const permissionValue = {};
  /**
   * Función recursiva para recorrer el árbol de permisos y asignar valores.
   * @param {Object} node Nodo actual en el árbol de permisos.
   */
  const traverseTree = node => {
    permissionValue[node.text] = node.value === '1';
    if (node.children) {
      node.children.forEach(subNode => {
        traverseTree(subNode);
      });
    }
  };
  permissions.forEach(permission => {
    traverseTree(permission);
  });
  return permissionValue;
};
